import { FC } from 'react';

import { PublisherAvatarContainer } from 'shared/components/PublisherAvatar';
import { useCardOfferPublisherContext } from 'shared/context/CardContext';
import { useListingLayoutIsShortSelector } from 'shared/store/clientSide/slices/listingLayout';
import { extractUndefined } from 'shared/utils/extractUndefined';

import { ContactActions } from '../ContactActions';
import { DocumentsChecked } from '../DocumentsChecked';
import { ErrorLogContainer } from '../ErrorLogComponent';
import { PublisherCardLayoutContainer } from '../PublisherCardLayout';
import { PublisherNameWithBadges } from '../PublisherNameWithBadges';
import { PublisherType } from '../PublisherType/PublisherType';

export const PublisherCard: FC = () => {
  const {
    extendedProperties: { documentsCheckedLabel, brandingLevel },
    typeLabels,
  } = useCardOfferPublisherContext();
  const isShortListing = useListingLayoutIsShortSelector();

  return (
    <ErrorLogContainer level="error">
      <PublisherCardLayoutContainer
        avatar={<PublisherAvatarContainer />}
        brandingLevel={extractUndefined(brandingLevel)}
        contactActions={<ContactActions />}
        documentsChecked={
          !isShortListing && !!documentsCheckedLabel && <DocumentsChecked text={documentsCheckedLabel} type="label" />
        }
        nameWithBadges={<PublisherNameWithBadges type={isShortListing ? 'compact' : 'full'} />}
        type={!!typeLabels && <PublisherType labels={typeLabels} />}
      />
    </ErrorLogContainer>
  );
};
